import { render, staticRenderFns } from "./NotSupported.vue?vue&type=template&id=6c6ac726&scoped=true&"
import script from "./NotSupported.vue?vue&type=script&lang=js&"
export * from "./NotSupported.vue?vue&type=script&lang=js&"
import style0 from "./NotSupported.vue?vue&type=style&index=0&id=6c6ac726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6ac726",
  null
  
)

component.options.__file = "NotSupported.vue"
export default component.exports